import React from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isIndexPage = location.pathname === '/';
  const isFullPageResults = location.pathname.includes('results-fullpage');

  return (
    <div className={`h-screen flex flex-col ${isIndexPage ? 'overflow-hidden' : ''}`}>
      <Logo />
      <main className={`flex-1 relative ${isIndexPage ? 'overflow-hidden' : ''} ${isFullPageResults ? 'max-w-full w-full p-0 m-0' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default Layout; 